import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { PaymentsAccountNumbersTable } from '../../../../../../../../../../features/payments/account-number/payments-account-numbers-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingFinancePayments,
      label: 'Account Numbers',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingFinancePayments>,
  head: () => getPageHead('Account Numbers'),
  component: PaymentsAchList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return <PageTabRail actions={filter} group={TabbedNavigationGroup.ClearingFinancePayments} />;
}

function PaymentsAchList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <PaymentsAccountNumbersTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
